import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { FlightEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-flight-loading-screen',
  templateUrl: './flight-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class FlightLoadingScreenComponent extends ProductLoadingScreen<FlightEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Flight]);
  }
}
